<template>
  <div class="pt-8">
      <SubscribeComponent v-if="!loading" :userData="userData" :image="image" :loading="loading"/>

      <!-- <v-skeleton-loader v-if="loading" type="list-item-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader> -->

             <v-dialog v-model="dialog" fullscreen v-if="loading">
            <div class="centerDiv">
          <v-progress-circular  :size="70" :width="5" indeterminate color="red">
            <v-img class="mx-auto" src="./../assets/Tippings.png" height="60px" width="60px" />
          </v-progress-circular>
           </div>
        </v-dialog>

        <v-container class="text-center pt-11 pa-6" v-if="notUser">
        <div>
         <h2>Sorry, {{theauthorName}} does not have an account on Tippings, yet</h2>
        <p class="mt-6">Are you <b>{{theauthorName}}?</b> Claim your Tippings page by tapping the button below </p>

        <v-btn rounded color="red" target="_blank" outlined x-large class="white--text" @click="getStarted()">Claim your page </v-btn>
        </div>
      </v-container>



    
  </div>
</template>

<script>
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import moment from "moment";
import db from "@/db";
import axios from "axios";
import { unslugify } from "unslugify"
import slugify from 'slugify'
import SubscribeComponent from '../components/SubscribeComponent.vue'

export default {
  data() {
    return {
      image: "",
      name: "",
      email: "",
      amount: "",
      dialog:true,
      successfulTip: false,
      flutterwaveRef: "",
      flwKey: "FLWPUBK-dbe851d7b426b96d183b36373de5959f-X",
      showTip: true,
      subscriberpayLoad: "",
      notificationsPayLoad: "",
      transactionPayload: "",
      paymentMethod: "",
      isProduction: true,
      country: "",
      showEdit: false,
      picture: "",
      imageData: "",
      editBio: false,
      snackbar: false,
      error: "",
      btnloading: false,
      loading:true,
      notUser:false,
      userData:{}
    };
  },
  
  components:{
   SubscribeComponent
  },

  computed: {
    referenceFlutter() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
     theauthorName(){
        return unslugify(this.$route.params.id)
     },
     
  },


  beforeCreate() {
    this.loading = true;
    getDoc(doc(db, "users", this.$route.params.id))
      .then(response => {
        this.userData = response.data();
        if (this.userData == null) {
          this.loading = false
          this.notUser = true
        } else if (this.userData != null) {
          this.image = response.data().photoURL;
        }
      })
      .then(() => {
        this.loading = false;
      });
  },

  watch: {
    flutterwaveRef() {
      this.changesInDatabase();
    }
  },

  created(){
     this.name = localStorage.getItem("name");
    this.email = localStorage.getItem("email");
  },
  methods: {
      getStarted(){
        localStorage.setItem('username',  this.slug = slugify(this.$route.params.id, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@]/g,
            lower: true,
          }))
        window.open("https://tippings.me/signup", '_blank')
      },

    goBack() {
      this.$router.go(-1);
    },

    async updateBio() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        bio: this.userData.bio,
        facebook: this.userData.facebook,
        twitter: this.userData.twitter,
        instagram: this.userData.instagram,
        linkedin: this.userData.linkedin,
        youtube: this.userData.youtube,
        tiktok: this.userData.tiktok
      });
      this.btnloading = false;
      this.$swal({
        title: "Profile updated successfully!",
        text: "Good job!. You've successfully updated your profile!",
        icon: "success",
        confirmButtonText: "Yay!"
      });
    },

    imageModal() {
      this.$refs.imageUpload.click();
    },

    onFileChanged(event) {
      this.$emit("onFileChanged", event, this.$refs.imageUpload.files[0]);
    },

    setName() {
      localStorage.setItem("name", this.name);
    },

    setEmail() {
      localStorage.setItem("email", this.email);
    },

    makePayment() {
      window.FlutterwaveCheckout({
        public_key: this.flwKey,
        tx_ref: this.reference,
        amount: this.amount,
        currency: this.currency,
        payment_options: this.payment_method,
        customer: {
          name: this.name,
          email: this.email
        },
        callback: response => this.callback(response),
        customizations: {
          title: this.custom_title,
          description: "Payment for items in cart",
          logo: this.custom_logo
        }
      });
    },

    close: () => {
      console.log("You closed checkout page");
      this.error = "You closed checkout page";
      this.snackbar = true;
    },

    callbackFlutter(response) {
      this.flutterwaveRef = response.referenceFlutter;
    },

    async changesInDatabase() {
      this.subscriberpayLoad = {
        name: this.name,
        email: this.email,
        amount: this.amount
      };
      this.transactionPayload = {
        name: this.name,
        email: this.email,
        fullname: this.name,
        title: "Tip payment",
        status: "successful",
        amount: `${parseFloat(this.amount)}`,
        timestamp: moment(Date.now()).format("LLL"),
        image: "https://i.ibb.co/8mRPfhc/credit-card-2.png"
      };

      (this.notificationsPayLoad = {
        title: "Tip received!",
        message: "You received a tip from " + this.name,
        timestamp: moment(Date.now()).format("LLL")
      }),
        await updateDoc(doc(db, "users", this.$route.params.id), {
          transactions: arrayUnion(this.transactionPayload),
          notifications: arrayUnion(this.notificationsPayLoad),
          subscribers: arrayUnion(this.subscriberpayLoad),
          wallet: arrayUnion(parseFloat(this.amount))
        });
      this.successfulTip = true;
      axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/mail",
        data: {
          from: `${this.userData.name} <support@tippings.me>`,
          email: this.userData.email,
          replyTo: this.userData.email,
          title: "You just received a tip from, " + this.name,
          message: `<h2>Congratulations, ${this.userData.name}</h2> <p> <b>${this.name}</b> just sent you <b>${this.amount}</b> on Tippings</p><p>You can now instantly withdraw your funds to your bank account.</p> <p>If you need customer support, send an email to <a href="support@tippings.me">support@tippings.me</a>`
        }
      }).then(response => {
        console.log(response);
      });
    }
  }
};
</script>
